import { action } from '@ember/object';
import { decodeTextWithLinks } from '../../utils/messaging/format-text';
import { fn } from '@ember/helper';
import { formatDate } from '../../utils/messaging/format-date';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import NegativeButton from 'ember-simplepractice/components/spds/action/button/negative';
import SpdsModalDestructive from 'ember-simplepractice/components/spds/modal/destructive';
import styles from './message.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class ConversationMessageMessage extends Component {
  @service alertManager;
  @service intl;
  @service messaging;
  @service store;

  @tracked showDeletionConfirmationModal = false;

  get showDeleteButton() {
    return this.messaging.currentProfile.isClinician && this.args.message.isDeletable;
  }

  @action
  toggleShowDeletionConfirmationModal() {
    this.showDeletionConfirmationModal = !this.showDeletionConfirmationModal;
  }

  @action
  async deleteMessage(message) {
    try {
      const adapter = this.store.adapterFor('messaging-message');
      await adapter.softDelete(this.store, message.id);
    } catch (error) {
      this.alertManager.broadcast('toast', {
        message: this.intl.t('emc.general_error'),
        type: 'error',
      });
    } finally {
      this.showDeletionConfirmationModal = false;
    }
  }

  <template>
    {{#if this.showDeleteButton}}
      <NegativeButton
        @iconOnly={{true}}
        {{on "click" this.toggleShowDeletionConfirmationModal}}
        class="delete-message-button"
        data-test-delete-message-button
      >
        {{svgJar "messaging-trash"}}
      </NegativeButton>
    {{/if}}

    <div class="{{styles.component}} message" data-test-message>
      <span class="message-text" data-test-message-text>
        {{decodeTextWithLinks @message.text}}
      </span>
      <div class="message-info">
        {{#if @message.isOwn}}
          <span data-test-sent-indicator>{{t "emc.sent"}}</span>
        {{else}}
          <span data-test-user-name>{{@message.user.name}}</span>
        {{/if}}
        <span class="time" data-test-created-at>· {{formatDate @message.createdAt}}</span>
      </div>
    </div>

    {{#if this.showDeletionConfirmationModal}}
      <SpdsModalDestructive
        @closeOnClickOutside={{true}}
        @onClose={{this.toggleShowDeletionConfirmationModal}}
        @primaryBtnAction={{fn this.deleteMessage @message}}
        @primaryBtnText={{t "emc.delete_message_modal.primary_button"}}
        @secondaryBtnAction={{this.toggleShowDeletionConfirmationModal}}
        @secondaryBtnText={{t "emc.delete_message_modal.secondary_button"}}
        data-test-delete-message-confirmation-modal
        as |M|
      >
        <M.Header @title={{t "emc.delete_message_modal.title"}} />
        <M.Body>
          <p>{{t "emc.delete_message_modal.first_paragraph"}}</p>
          <p>{{t "emc.delete_message_modal.second_paragraph"}}</p>
        </M.Body>
      </SpdsModalDestructive>
    {{/if}}
  </template>
}
